import React, { createContext, useContext, FC } from "react";
import { InsuranceLabelsDto } from "@apiModels/Insurance/Labels/InsuranceLabelsDto.csharp";

type LabelsContext = {
  labels: InsuranceLabelsDto;
};

const Context = createContext<InsuranceLabelsDto | null>(null);

export const InsuranceLabelsContext: FC<LabelsContext> = (props) => {
  const { labels, children } = props;

  return <Context.Provider value={{ ...labels }}>{children}</Context.Provider>;
};

export const useInsuranceLabels = () => {
  const context = useContext(Context);

  if (!context) {
    throw new Error("Context has not been initialized");
  }

  return context;
};
